import React from 'react';
import{Form,FormGroup,Button,Row,Col} from 'react-bootstrap'
import './About.css'
const About = () => {
    return (
        <div className='pridivabout'>
          
<div>

<h1 className='h2about'>আমাদের লক্ষ্য</h1>
<p className='p1about'>জলবায়ু পরিবর্তনের বিরূপ প্রভাব প্রতিরোধের জন্য গাছ লাগানো জরুরি হলেও গড়ে প্রতি ২৪ ঘণ্টায় দেশের <br/>প্রায় ১ লাখ ৩০ হাজার পরিবেশবান্ধব ফুল ও ফলের গাছ কাটা হচ্ছে।
 অথচ লাগানো হচ্ছে মাত্র ৩০ হাজার।<br/>(সূত্রে: বাংলাদেশ নার্সারি সমিতি)<br/>যার ভলে পরিবেশের ভারসাম্য নষ্ট হচ্ছে  শুধুমাত্র পরিবেশের ভারসাম্য নষ্ট নয়, গাছ আমাদের বিভিন্নভাবে সহায়তা করে।<br/>
তাই আমরা মনেকরি, গাছপালা ধ্বংস ও বৃক্ষচ্ছেদন রোধ করার জন্য আমাদের জনসাধারণকে বৃক্ষ রোপণে উৎসাহিত করতে হবে।<br/>অ্যাপ্লিকেশনটি কৃষক এবং জনসাধারণকে গাছের পরিচর্যা করার নিয়মগুলো জানতে এবং বিভিন্ন জাতের বৃক্ষ রোপণে উৎসাহিত করবে।</p>
<h1 className='h3about'>আমাদের অ্যাপ্লিকেশন সম্পর্কে</h1>
<p className='p2about'> এই অ্যাপ্লিকেশনটি কৃষক এবং জনসাধারণকে গাছের পরিচর্যা করার নিয়মগুলো জানতে এবং বিভিন্ন জাতের গাছ রোপণে উৎসাহিত করবে।<br/>
গাছ রোপণের নির্দেশাবলীর জন্য আমরা আমাদের ওয়েব অ্যাপ্লিকেশনে কিছু বিনামূল্যের ভিডিও রেখেছি। <br/>
আমদের অ্যাপ্লিকেশনে গাছের পরিচর্যা করার নিয়ম এবং বিভিন্ন জাতের বৃক্ষ রোপণের সর্বশেষ খবর, ভিডিও, কোর্স এবং ইকমার্স প্রদান করেছি। <br/>আমরা কৃষকদের জন্য আমাদের ওয়েব অ্যাপ্লিকেশনে ইকমার্স বৈশিষ্ট্য ব্যবহার করেছি যার ব্যবহার করে আধুনিক কৃষি যন্ত্রপাতি,বিদেশি ফলের গাছ, এবং নতুন আবিষ্কৃত উদ্ভিদ কিনতে পারবে।</p> </div>
<div>
<section id="our-testimonial" class="padding">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-sm-12 text-center">
        <div class="heading-title bottom30 wow fadeInUp" data-wow-delay="300ms">
          <h2 class="amaderdol">আমাদের দলের সদস্যরা</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div id="testimonial-slider" class="owl-carousel">
          <div class="item">
            <div class="testimonial-wrapp"> <span class="quoted"><i class="fa fa-quote-right"></i></span>
              <div class="testimonial-text">
                <p class="bottom40">আমি এই ওয়েব এপ্লিকেশনে এর ফ্রন্ট এন্ড ডেভেলপারে ও ব্যাক-এন্ড ডেভেলপার হিসেবে নিয়োজিত ছিলাম।</p>
              </div>
              <div class="testimonial-photo"><img alt="" src="https://i.ibb.co/jftFtSn/salim.jpg"/></div>
              <h4 class="darkcolor">Salim Raza Joy</h4>
              <small class="defaultcolor">Full Stack Developer</small> </div>
          </div>
          <div class="item">
            <div class="testimonial-wrapp"> <span class="quoted"><i class="fa fa-quote-right"></i></span>
              <div class="testimonial-text">
                <p class="bottom40">টিমওয়ার্ক ছাড়া এই প্রজেক্টি করার অসম্ভব ছিল। আমি এই ওয়েব এপ্লিকেশনে ইউআই/ইউএক্স ডিজাইনার ও ফ্রন্ট এন্ড ডেভেলপারে হিসেবে নিয়োজিত ছিলাম।</p>
              </div>
              <div class="testimonial-photo"><img alt="" src="https://i.ibb.co/K6cR41y/IMG-20200510-010716-674.jpg"/></div>
              <h4 class="darkcolor">Sakib Sarker</h4>
              <small class="defaultcolor">Frontend Developer</small> </div>
          </div>
          <div class="item">
            <div class="testimonial-wrapp"> <span class="quoted"><i class="fa fa-quote-right"></i></span>
              <div class="testimonial-text">
                <p class="bottom40">আমি এই ওয়েব এপ্লিকেশনে ইউআই ডিজাইনার ও কন্টেন্ট ডেভেলপার হিসেবে নিয়োজিত ছিলাম।</p>
              </div>
              <div class="testimonial-photo"><img alt="" src="https://i.postimg.cc/K8XgqmtH/274989892-493596848843608-6440486483695449741-n.jpg"/></div>
              <h4 class="darkcolor">Sheikh Foysal</h4>
              <small class="defaultcolor">Content Developer</small> </div>
          </div>
          
          
        </div>
      </div>
    </div>
  </div>
</section>
</div>
<div><h1 className='conus'>যোগাযোগ করুন</h1></div>
<div className='form7'><div class="container mt-5">
<form class="row g-3">
<div class="col-md-6">
  <label for="firstName" class="form-label">নামের প্রথম অংশ</label>
  <input type="text" class="form-control" id="firstname" required></input>
</div>
<div class="col-md-6">
  <label for="firstName" class="form-label">নামের শেষাংশ</label>
  <input type="text" class="form-control" id="firstname" required></input>
</div>
<div class="col-md-8">
  <label for="emailInfo" class="form-label">ইমেইল</label>
  <input type="Email" class="form-control" id="emailInfo" required></input>
</div>
<div class="col-md-4">
  <label for="phoneNumber" class="form-label">ফোন</label>
  <input type="text" class="form-control" id="phoneNumber" placeholder="+৮৮"></input>
</div>
<div class="col-md-12">
  <label for="comments" class="form-label">মন্তব্য, প্রশ্ন?</label>
  <textarea class="form-control" id="comments" row="3"></textarea>
</div>
<div  class="col-md-12">
  <button type="submit" class="btn btn-secondary">মন্তব্য পাঠান</button>
</div>
</form>
</div></div>


</div>
    );
};

export default About;